import { Controller } from '@hotwired/stimulus';

// alertify は Sprockets の manage.js がグローバルに読み込んでいる
export default class extends Controller {
  connect() {
    const { success, warn, error, notice, alert } = this.element.dataset;

    if (success) alertify.notify(success, 'success', 5);
    if (warn) alertify.notify(warn, 'info', 5);
    if (error) alertify.notify(error, 'error', 0);
    if (notice) alertify.notify(notice, 'info', 5);
    if (alert) alertify.notify(alert, 'error', 0);
  }
}
